module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.users')))]), _vm._v(" "), _c('base-list', {
    attrs: {
      "model": "users",
      "columns": ['first_name', 'email'],
      "s-model": "user"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e46f20a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserList.vue
// module id = 1192
// module chunks = 2